import {Component, OnDestroy, OnInit} from "@angular/core";
import {Subscription} from "rxjs";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DatePipe, NgClass, NgForOf, NgIf, NgOptimizedImage, NgStyle} from "@angular/common";
import {HistoryRound, HistoryRoundBuddy, RoundFormatType, RoundFormatTypeEnum, ScoringMethodType, ScoringSettings,} from "./model/round-history";
import {RoundHistoryService} from "./round-history.service";
import {Router} from "@angular/router";
import {GroupProfileImageComponent} from "../common/component/profile/group-profile-image/group-profile-image.component";
import {TextWithIcon} from "./text-with-icon/text-with-icon.component";
import {ScoreComponent} from "./score/score.component";
import {ProfileImage} from "../common/component/profile/model/profile";

@Component({
    standalone: true,
    selector: 'round-history',
    templateUrl: './round-history.component.html',
    imports: [
        ReactiveFormsModule,
        NgForOf,
        FormsModule,
        NgOptimizedImage,
        DatePipe,
        GroupProfileImageComponent,
        TextWithIcon,
        TextWithIcon,
        ScoreComponent,
    ],
    styleUrls: ['./round-history.component.css']
})
export class RoundHistoryComponent implements OnInit, OnDestroy {
    private subscriptions: Subscription[] = [];

    isLoading: boolean = false;
    historyRoundList: HistoryRound[] = []

    constructor(private service: RoundHistoryService, private router: Router) {

    }

    ngOnInit() {
        this.isLoading = true

        this.subscriptions.push(this.service.getRoundHistory()
            .subscribe({
                next: (roundList) => {
                    this.historyRoundList = roundList.roundList
                    this.isLoading = false
                },
                error: (err: string) => {
                    console.log(err)
                    this.isLoading = false
                },
            }));
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    getBuddiesString(buddies: HistoryRoundBuddy[]): string {
        const count = buddies.length;
        const names = buddies.map(buddy => buddy.name);

        switch (count) {
            case 0:
                return ''
            case 1:
                return `with ${names[0]}`;
            case 2:
                return `with ${names[0]} and ${names[1]}`;
            default:
                return `with ${names[0]}, ${names[1]} and ${count - 2} others`;
        }
    }

    getScoringInfo(settings: ScoringSettings, format: RoundFormatType): string {
        let scoringMethod: string;
        let formatValue: string | null;
        switch (settings.scoringMethod.type) {
            case ScoringMethodType.Stableford:
                scoringMethod = 'Stableford';
                break;
            case ScoringMethodType.Skins:
                scoringMethod = 'Skins';
                break;
            case ScoringMethodType.StrokePlay:
                scoringMethod = 'Stroke Play';
                break;
            case ScoringMethodType.MathPlay:
                scoringMethod = 'Math Play';
                break;
            case ScoringMethodType.Nines:
                scoringMethod = 'Nines';
                break;
            default:
                scoringMethod = settings.scoringMethod.type;
                break;
        }
        switch (format.type) {
            case RoundFormatTypeEnum.Individual:
                formatValue = null;
                break;
            case RoundFormatTypeEnum.TeamBestBall:
                formatValue = 'Best ball';
                break;
            case RoundFormatTypeEnum.TeamScramble:
                formatValue = 'Scramble';
                break;
            default:
                formatValue = format.type;
                break;
        }
        return `${settings.handicapMode} | ${scoringMethod}${formatValue ? ' | ' + formatValue : ''}`;
    }

    navigateRound(token: string) {
        this.router.navigate([`/round/${token}`])
    }

    getProfileImages(buddies: HistoryRoundBuddy[]): ProfileImage[] {
        return buddies.map(buddy => buddy.image)
    }
}
